import { AuthEnvironment } from "./backend/interfaces/IAuthenticationProvider";

export const RETRY_SETTINGS = {
    maxRetries: 3,
    retryWaitMilliseconds: 5000
};

export const RETRY_SETTINGS_REQUEST_TIMED_OUT = {
  maxRetries: 10,
  retryWaitMilliseconds: 30000 //30 sec
};

// Defined in webpack.config.js
declare const __APP_VERSION__: string;
declare const __APP_INTERNAL_NAME__: string;
declare const __IS_DEV_BUILD__: boolean;

export const APP_VERSION = __APP_VERSION__;
export const APP_INTERNAL_NAME = __APP_INTERNAL_NAME__;
export const IS_DEV_BUILD = __IS_DEV_BUILD__;

export const TELEMETRY_EVENT_AGGREGATION_TIME_INTERVAL_MILLISECONDS = 60000;
export const MAX_UNRESPONSIVENESS_WAIT_TIME_MILLISECONDS = 30000;
export const MAX_BOOT_TIME_MILLISECONDS = 60000;
export const MAX_INDEXED_DB_INITIALIZE_TIME_MILLISECONDS = 10000;
export const MAX_MINUTES_GET_TIME_MILLISECONDS = 60000;
export const MAX_MINUTES_WAIT_TIME_FOR_XML_STORAGE_OPERATION_MILLISECONDS = 30*60*1000; //15 min
export const AUTH_ENVIRONMENT_DEFAULT: AuthEnvironment = 1;
export const MAX_MINUTES_WAIT_TIME_FOR_XML_STORAGE_GET_NAMESPACE_PART_MILLISECONDS = 5*60*1000;

// IMPORTANT! During local debugging, please change HOST_APP_DEFAULT value to app where you are debugging.
export const HOST_APP_DEFAULT: string = "WORD";
export const HOST_PLATFORM_WIN32: string = "PC";
export const HOST_PLATFORM_WEB: string = "OFFICEONLINE";

export const DEV_SSO_LOGIN_URL: string = "https://fa000000051.resources.office.net:3000/login.html";
export const DOGFOOD_SSO_LOGIN_URL: string = "https://fa000000051.resources.office.net/f7024bdc-7caf-4ca8-807d-2908f09640d6/1.1.2311.6002/en-us_web/login_dogfood.html";
export const DOGFOOD_SSO_LOGIN_URL_1CDN: string = "https://fa000000051.mro1cdnstorage.public.onecdn.static.microsoft/mro1cdnstorage/f7024bdc-7caf-4ca8-807d-2908f09640d6/sdx/fa000000051/1.1.2511.4002/en-us_web/login_dogfood.html";
export const MSIT_SSO_LOGIN_URL: string = "https://fa000000051.resources.office.net/f7024bdc-7caf-4ca8-807d-2908f09640d6/1.1.2006.3005/en-us_web/login.html";
export const MSIT_SSO_LOGIN_URL_1CDN: string = "https://fa000000051.mro1cdnstorage.public.onecdn.static.microsoft/mro1cdnstorage/f7024bdc-7caf-4ca8-807d-2908f09640d6/sdx/fa000000051/1.1.2511.4002/en-us_web/login.html";
export const PROD_SSO_LOGIN_URL: string = "https://fa000000051.resources.office.net/f7024bdc-7caf-4ca8-807d-2908f09640d6/1.1.2006.3005/en-us_web/login.html";
export const PROD_SSO_LOGIN_URL_1CDN: string = "https://fa000000051.mro1cdnstorage.public.cdn.office.net/mro1cdnstorage/033f92d3-bc6d-439a-858a-a17acf70360a/sdx/fa000000051/1.1.2505.5003/en-us_web/login_dogfood.html";
// TODO: Update AG08 and AG09 SSO login URLs with correct version after deployment and set redirecturi in 1p repo
export const AG08_SSO_LOGIN_URL: string = "https://fa000000051.mro1cdnstorage.1cdn.eaglex.ic.gov/mro1cdnstorage/033f92d3-bc6d-439a-858a-a17acf70360a/sdx/fa000000051/1.1.2510.7002/en-us_web/login_ag08.html";
export const AG09_SSO_LOGIN_URL: string = "https://fa000000051.mro1cdnstorage.1cdn.microsoft.scloud/mro1cdnstorage/033f92d3-bc6d-439a-858a-a17acf70360a/sdx/fa000000051/1.1.2510.7002/en-us_web/login_ag09.html";

export const LOG_AUGLOOP_RUNTIME_EVENTS_TO_CONSOLE_BROWSER_ENABLED: boolean = IS_DEV_BUILD;
export const LEARN_MORE_URL: string = "https://support.office.com/article/7fc2efec-245e-45f0-b053-2a97531ecf57";
export const PRIVACY_POLICY_URL: string = "https://go.microsoft.com/fwlink/p/?LinkId=123161";
export const DEV_AUGLOOP_URL: string = "wss://augloop-msit.office.com";
export const ICON_DEFAULT_BASE_URL: string = "https://res.cdn.office.net/files/fabric-cdn-prod_20210407.001/assets/icons/";
export const ICON_USSEC_BASE_URL: string = "https://modern.azure.odsp.microsoft.scloud/files/fabric-cdn-prod_20210407.001/assets/icons/";
export const ICON_USNAT_BASE_URL: string = "https://modern.azure.odsp.eaglex.ic.gov/files/fabric-cdn-prod_20210407.001/assets/icons/";
export const DEV_FRONTDOOR_BASE_URL = 'https://pptservicescast.edog.officeapps.live.com/SpeechHandler.ashx';
// TODO: Replace this url with the transcribing help page url
export const MICROPHONE_PERMISSION_HELP_PAGE_URL: string = "https://support.microsoft.com/en-us/office/troubleshoot-dictation-issues-in-microsoft-365-for-the-web-5e69be5f-4357-43f0-a99a-ed903443cd9b";
export const FRONTDOOR_UPLOAD_WAIT_TIMEOUT_MILLISECONDS = 1800000; // 30 minutes
export const GET_BATCH_CONVERSATION_TRANSCRIPTION_TIMEOUT_MILLISECONDS = 600000; // 10 minutes

export const AUGLOOP_CONNECT_TIMEOUT_MILLISECONDS = 30000;

export const ACCEPTED_FILE_FORMATS_FOR_UPLOAD = ".wav, .mp4, .m4a, .mp3";

export const AVAILABLE_UPLOAD_MINUTES_PER_MONTH = 300;
export const NEW_AVAILABLE_UPLOAD_MINUTES_PER_MONTH = 30000;

export const FILE_UPLOAD_POLLING_DELAY_MILLISECONDS = 5000;
export const RESUME_UPLOAD_WAIT_TIME_MILLISECONDS = 10000; // 10 seconds
export const RESUME_UPLOAD_RETRY_COUNT = 3;
export const ONE_MB_IN_BYTES = 1024 * 1024;// 1KB = 1024 bytes, 1MB = 1024 * 1024
export const ROAMING_SETTING_MONTHLY_QUOTA_KEY = "ridTranscriptionQuotaMinutesUsed";
export const MAX_AUGLOOP_SESSION_INIT_RETRY_ALLOWED = 2;
export const AUGLOOP_INIT_RETRY_DELAY_MILLISECONDS = 3000;

export const PERMISSION_GRANTED = "granted";
export const PERMISSION_DENIED = "denied";
export const PERMISSION_PROMPT = "prompt";

export const FILE_UPLOAD_MAX_FILE_SIZE_BYTES = 300 * 1000 * 1000; // 300 MB
export const RECOVERY_FLOW_MAX_FILE_SIZE_BYTES = 1000 * 1000 * 1000; // 1000 MB

//PPE
export const ONEDRIVE_TOKEN_BASE_URL_FOR_ODB_PPE = "https://api.onedrive-ppe.com"; //TODO: confirm this URL while testing for ppe.
export const ONEDRIVE_TOKEN_BASE_URL_FOR_ODP_PPE = "onedrive.readwrite-ppe"; //TODO: confirm this URL while testing for ppe.

//PROD
export const ONEDRIVE_TOKEN_BASE_URL_FOR_ODB_PROD = "https://api.onedrive.com";
export const ONEDRIVE_TOKEN_BASE_URL_FOR_ODP_PROD = "onedrive.readwrite";
export const ONEDRIVE_API_BASE_URL = "https://api.onedrive.com/v1.0";

// This is wait duration starting when network goes offline,
// after this duration, app will again try to check network connected or not
// This wait time will give other components (ex, file upload) to recover from network fluctuation.
export const WAIT_TIME_FOR_NETWORK_RECONNECT_MILLIS = 60000; // 60 seconds
export const AUTH_CONTEXT_LOAD_DELAY_MILLIS = 2000; // 2 seconds
export const AUTH_CONTEXT_LOAD_DELAYMSAL_MILLIS = 5000; // 5 seconds

// File path to send a fetch request
// This path is used for checking whether network is online or not
export const PING_FILE_PATH = "assets/ping_image.png";

export const TRANSCRIPTION_SIGNAL_INDICATOR_PATH = "assets/transcription_signal_indicator.png";
export const EMPTY_STRING = "";
export const COMMA = ", ";
export const SPACE = " ";

export enum AddToDocumentResult {
  TIMED_OUT,
  SUCCESS,
  FAILURE
}

export const MAX_WAIT_TIME_FOR_ADD_TO_DOCUMENT_REQUEST = 5*60*1000; // 3 min

export const MAX_LINKED_PAGE_INFO_LOAD_RETRY_ALLOWED = 3;
export const LINKED_PAGE_INFO_LOAD_RETRY_DELAY_MILLISECONDS = 5000;

export const NOTIFY_LISTENER_TIMER_VALUE = 5000;

/* Every 20 sec a ping is sent to ensure connectivity by
NetworkConnectionMonitor in case ping service is started by some listener.*/
export const NETWORK_PING_INTERVAL = 20000;

export enum FileUploadEntryPoints {
  DEFAULT = "DEFAULT",
  RECOVERING = "RECOVERING"
}

export enum TranscribingEntryPoints {
  DEFAULT = 'DEFAULT', //for transcription from existing media
  FILE_UPLOAD = 'FILE_UPLOAD',
  LIVE_RECORDING = 'LIVE_RECORDING'
}

export const ERROR_AUGLOOP_ACTIVE_ANNOTATIONS = 'ErrorAugloopActivateAnnotations'

export const DROPDOWN_TRANSCRIPTION_LOCALE = 'dropDownTranscriptionLocale'

export const GRAPH_API_ONE_DRIVE_ITEM_FETCH_RETRY_ATTEMPTS = 2;

export const GRAPH_API_ONE_DRIVE_ITEM_FETCH_WAIT_TIME = 1000;

export const MAX_RETRY_ATTEMPTS_FOR_WRITE_REQUEST = 2;

export const MAX_RETRY_DELAY_FOR_WRITE_REQUEST_IN_MSEC = 1000;

export const CHANGE_GATE_PREFIX = 'Microsoft.Office.Transcript.FA000000051.';

export const CHANGE_GATE_WIN32_PREFIX = 'Microsoft.Office.Word.FA000000051.';